import { ICoSo } from "../../model/respone/category/ICoSo";
import { apiClient } from "../apiClient";
export const CoSo_ENDPOINT = "co-so";
export const coSoApi = {
  SelectAll: () => apiClient.get(`${CoSo_ENDPOINT}`),
  Insert: (payload: ICoSo) => apiClient.post(`${CoSo_ENDPOINT}`, payload),
  Update: (payload: ICoSo) => apiClient.put(`${CoSo_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${CoSo_ENDPOINT}/${id}`),
};
